import script from "./AddOccasion.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOccasion.vue?vue&type=script&setup=true&lang=js"

import "./AddOccasion.vue?vue&type=style&index=0&id=bcf850e2&scoped=true&lang=css"

import exportComponent from "D:\\repository\\vue\\yadino-marketplace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcf850e2"]])

export default __exports__